(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7669],{

/***/ 37802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farms",
      function () {
        return __webpack_require__(32942);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var config_constants_supportChains__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20277);
/* harmony import */ var views_Farms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3029);
/* harmony import */ var views_Farms_components_FarmCard_FarmCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22625);
/* harmony import */ var views_Farms_components_getDisplayApr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6774);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8919);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51523);
/* harmony import */ var views_Farms_components_YieldBooster_components_ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65563);









var ProxyFarmCardContainer = function(param) {
    var farm = param.farm;
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_7__/* .useAccount */ .mA)(), account = ref.address;
    var cakePrice = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_5__/* .usePriceCakeBusd */ .Iu)();
    console.log("a");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(views_Farms_components_YieldBooster_components_ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_6__/* .YieldBoosterStateContext */ ._), proxyFarm = ref1.proxyFarm, shouldUseProxyFarm = ref1.shouldUseProxyFarm;
    var finalFarm = shouldUseProxyFarm ? proxyFarm : farm;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Farms_components_FarmCard_FarmCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        farm: finalFarm,
        displayApr: (0,views_Farms_components_getDisplayApr__WEBPACK_IMPORTED_MODULE_8__/* .getDisplayApr */ .V)(finalFarm.apr, finalFarm.lpRewardsApr),
        cakePrice: cakePrice,
        account: account,
        removed: false
    }, finalFarm.pid);
};
var FarmsPage = function() {
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_7__/* .useAccount */ .mA)(), account = ref.address;
    var chosenFarmsMemoized = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(views_Farms__WEBPACK_IMPORTED_MODULE_3__/* .FarmsContext */ .GX).chosenFarmsMemoized;
    var cakePrice = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_5__/* .usePriceCakeBusd */ .Iu)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: chosenFarmsMemoized.map(function(farm) {
            return farm.boosted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Farms_components_YieldBooster_components_ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                farm: farm,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProxyFarmCardContainer, {
                    farm: farm
                })
            }, farm.pid) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Farms_components_FarmCard_FarmCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                farm: farm,
                displayApr: (0,views_Farms_components_getDisplayApr__WEBPACK_IMPORTED_MODULE_8__/* .getDisplayApr */ .V)(farm.oscarApr, farm.lp),
                wethApr: (0,views_Farms_components_getDisplayApr__WEBPACK_IMPORTED_MODULE_8__/* .getDisplayApr */ .V)(farm.wethApr, farm.lp),
                stableApr: (0,views_Farms_components_getDisplayApr__WEBPACK_IMPORTED_MODULE_8__/* .getDisplayApr */ .V)(farm.stableApr, farm.lp),
                cakePrice: cakePrice,
                account: account,
                removed: false
            }, farm.pid);
        })
    });
};
FarmsPage.Layout = views_Farms__WEBPACK_IMPORTED_MODULE_3__/* .FarmsPageLayout */ .Sf;
FarmsPage.chains = config_constants_supportChains__WEBPACK_IMPORTED_MODULE_2__/* .SUPPORT_FARMS */ .RD;
/* harmony default export */ __webpack_exports__["default"] = (FarmsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8859,9370,2135,8392,8046,4270,4458,9517,9774,2888,179], function() { return __webpack_exec__(37802); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);